import * as React from 'react';

function AlertTriangle(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...props}>
      <path d="M8.9999 7.24989V8.74989M8.9999 11.7499V11.7574M3.7499 14.7499H14.2499C14.4946 14.7482 14.7352 14.6866 14.9507 14.5705C15.1662 14.4545 15.35 14.2875 15.4861 14.0841C15.6222 13.8807 15.7064 13.647 15.7315 13.4036C15.7566 13.1601 15.7217 12.9143 15.6299 12.6874L10.3049 3.49989C10.1752 3.26544 9.98503 3.07001 9.75421 2.93393C9.5234 2.79785 9.26034 2.72607 8.9924 2.72607C8.72445 2.72607 8.4614 2.79785 8.23058 2.93393C7.99977 3.07001 7.80962 3.26544 7.6799 3.49989L2.3549 12.6874C2.26485 12.9091 2.22915 13.1491 2.25076 13.3874C2.27237 13.6257 2.35068 13.8553 2.47914 14.0572C2.6076 14.2591 2.78248 14.4273 2.98919 14.5478C3.1959 14.6683 3.42844 14.7376 3.6674 14.7499" stroke="#B61E0A" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default AlertTriangle;
